/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import HomePage from "../pages/home/HomePage";
import AuthPage from "../pages/auth/AuthPage";
import ErrorsPage from "../pages/errors/ErrorsPage";
import LogoutPage from "../pages/auth/Logout";
import { LayoutContextProvider } from "../../_metronic";
import * as routerHelpers from "../router/RouterHelpers";
import SnackBar from "../widgets/_componentes/SnackBar";
import DesconhecidoAcessarSala from '../pages/desconhecido/acessar-sala';

import axios from "axios";
import * as Branding from "../store/ducks/branding.duck";
import * as Auth from "../store/ducks/auth.duck";
import {toAbsoluteRestUrl} from "../../_metronic";
import { getUserByToken } from "../crud/auth.crud";

export const Routes = withRouter(({ Layout, Store, history }) => {
  const lastLocation = useLastLocation();
  routerHelpers.saveLastLocation(lastLocation);
  const { branding, isAuthorized, menuConfig, userLastLocation } = useSelector(
    ({ branding, auth, urls, builder: { menuConfig } }) => ({
      menuConfig,
      isAuthorized: auth.user != null,
      userLastLocation: routerHelpers.getLastLocation(),
      branding
    }),
    shallowEqual
  );

  // request branding
  if(!document.brandingRequested) {
      document.brandingRequested = true;

      axios.get(toAbsoluteRestUrl("/branding"))
      .then(response => {
          if(response.data) {
              Store.dispatch(Branding.actions.changeBranding(response.data));
          }
      });
  }

  // Check if session didn't expired in server
  if(isAuthorized && !document.authorizationValidated) {
    document.authorizationValidated = true;
    getUserByToken().then (
        response => {
            if(!response.data.id) {
                Store.dispatch(Auth.actions.logout());
            }
        }
    );
  }

  // Only render when software_name is available
  if(!branding.software_name)
      return <div>Loading</div>;

  return (
    /* Create `LayoutContext` from current `history` and `menuConfig`. */
    <LayoutContextProvider history={history} menuConfig={menuConfig}>
      <Switch>
        {!isAuthorized ? (
          /* Render auth page when user at `/auth` and not authorized. */
          <Route path="/auth/login" component={AuthPage} />
          ) : (
          /* Otherwise redirect to root page (`/`) */
          <Redirect from="/auth/login" to={userLastLocation} />
          )}

        {!isAuthorized ? (
          /* Render auth page when user at `/auth` and not authorized. */
          <Route path="/auth" component={AuthPage} />
        ) : (
          /* Otherwise redirect to root page (`/`) */
          <Redirect from="/auth" to={userLastLocation} />
        )}

        <Route path="/error" component={ErrorsPage} />
        <Route path="/logout" component={LogoutPage} />

        {!isAuthorized ? (
            /* Renderiza a rota de acesso do visitante apenas se não estiver logado */
            <Route path="/:slug([0-9a-z]{1,20})" component={DesconhecidoAcessarSala} />
        ) : null}

        {!isAuthorized ? (
          /* Redirect to `/auth` when user is not authorized */
          <Redirect to="/auth/login" />
        ) : (
          <Layout>
            <SnackBar />
            <HomePage userLastLocation={userLastLocation} />
          </Layout>
        )}
      </Switch>
    </LayoutContextProvider>
  );
});
